/* BIGDORA SHIPMENTS v4.5 - Drawer routes to dedicated Order Planner */
(function () {
  const STORAGE_KEY = 'bigdora_shipments_v1';
  const WIZARD_STEP_KEY = 'bigdora_shipments_wizard_step_v4';
  const WIZARD_RESUME_ONCE_KEY = 'bigdora_shipments_wizard_resume_once_v4';
  const WIZARD_RESUME_OVERRIDE_KEY = 'bigdora_shipments_wizard_resume_override_v4';
  const IS_CART_PAGE = window.location.pathname === '/cart';

  function defaultState() {
    return {
      nextId: 1,
      groups: {},
      assignments: {},
      lineMeta: {}
    };
  }

  function loadState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultState();

      const parsed = JSON.parse(raw);

      return {
        nextId: parsed.nextId || 1,
        groups: parsed.groups || {},
        assignments: parsed.assignments || {},
        lineMeta: parsed.lineMeta || {}
      };
    } catch (e) {
      return defaultState();
    }
  }

  let state = loadState();

  /*
    v4.4:
    Kullanıcı /cart sayfasını normal şekilde açtığında wizard HER ZAMAN
    ilk adım olan "Ürünleri Ayır" ekranından başlar.

    Yalnızca scriptin kendi yaptığı teknik cart reload'larında mevcut işlem
    adımını bir kez koruyoruz; böylece fulfillment hizmet satırı senkronu
    kullanıcıyı geriye atmaz.
  */
  if (IS_CART_PAGE) {
    try {
      const resumeOnce = sessionStorage.getItem(WIZARD_RESUME_ONCE_KEY);

      if (resumeOnce) {
        sessionStorage.setItem(WIZARD_STEP_KEY, resumeOnce);
        sessionStorage.removeItem(WIZARD_RESUME_ONCE_KEY);
      } else {
        sessionStorage.setItem(WIZARD_STEP_KEY, 'assign');
      }
    } catch (e) {}
  }

  Object.keys(state.groups || {}).forEach(function (groupId) {
    if (!state.groups[groupId].token) {
      state.groups[groupId].token =
        'ff-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    }
  });

  saveState();

  let ffSyncRunning = false;
  let ffSyncTimer = null;
  let wizardAssignmentsDirty = false;
  let wizardCommitRunning = false;

  function saveState() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  function groupNumber(id) {
    return parseInt(String(id).replace('shipment-', ''), 10) || 0;
  }

  function sortedGroups() {
    return Object.keys(state.groups).sort(function (a, b) {
      return groupNumber(a) - groupNumber(b);
    });
  }


  function groupIdFromName(name) {
    const match = String(name || '').match(/Fulfillment Müşterisi\s+(\d+)/i);
    return match ? 'shipment-' + match[1] : '';
  }

  function ensureGroup(groupId, name) {
    if (!groupId || groupId === 'dealer') return null;

    if (!state.groups[groupId]) {
      const num = groupNumber(groupId) || 1;

      state.groups[groupId] = {
        id: groupId,
        name: name || ('Fulfillment Müşterisi ' + num),
        token: 'ff-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10),
        carrier: '',
        code: '',
        barcodeUrl: '',
        barcodeName: ''
      };
    }

    return state.groups[groupId];
  }

  function captureLineMetaFromDOM() {
    document
      .querySelectorAll('.bigdora-shipment-selector[data-line-key]')
      .forEach(function (wrapper) {
        const key = wrapper.dataset.lineKey;
        if (!key) return;

        const row = wrapper.closest('.cart-items__table-row');
        const titleEl = row ? row.querySelector('.cart-items__title') : null;
        const imageEl = row ? row.querySelector('.cart-items__media-image') : null;

        let variantText = wrapper.dataset.variantTitle || '';

        if (!variantText && row) {
          const variants = row.querySelector('.cart-items__variants');

          if (variants) {
            variantText = variants.textContent
              .replace(/\s+/g, ' ')
              .replace(/,\s*$/, '')
              .trim();
          }
        }

        state.lineMeta[key] = Object.assign(
          {},
          state.lineMeta[key] || {},
          {
            title:
              wrapper.dataset.productTitle ||
              (titleEl ? titleEl.textContent.trim() : ''),
            variant: variantText,
            image:
              wrapper.dataset.productImage ||
              (imageEl ? (imageEl.currentSrc || imageEl.src || '') : ''),
            url:
              wrapper.dataset.productUrl ||
              (titleEl ? titleEl.getAttribute('href') || '' : ''),
            variantId: parseInt(wrapper.dataset.variantId || '0', 10) || 0,
            fee: parseFloat(wrapper.dataset.ffBedel || '0') || 0
          }
        );
      });

    saveState();
  }

  function createGroup() {
    let num = 1;

    while (state.groups['shipment-' + num]) {
      num += 1;
    }

    const id = 'shipment-' + num;

    state.groups[id] = {
      id: id,
      name: 'Fulfillment Müşterisi ' + num,
      token: 'ff-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10),
      carrier: '',
      code: '',
      barcodeUrl: '',
      barcodeName: ''
    };

    state.nextId = num + 1;
    saveState();

    return id;
  }

  function cleanupGroups() {
    const used = {};

    Object.keys(state.assignments).forEach(function (lineKey) {
      const groupId = state.assignments[lineKey];

      if (groupId && groupId !== 'dealer') {
        used[groupId] = true;
      }
    });

    Object.keys(state.groups).forEach(function (groupId) {
      if (!used[groupId]) {
        delete state.groups[groupId];
      }
    });

    saveState();
  }

  function updateSelectOptions(select) {
    const wrapper = select.closest('.bigdora-shipment-selector');
    if (!wrapper) return;

    const lineKey = wrapper.dataset.lineKey;
    const current = state.assignments[lineKey] || 'dealer';

    let html = '<option value="dealer">Size gelecek</option>';

    sortedGroups().forEach(function (groupId) {
      const group = state.groups[groupId];

      html +=
        '<option value="' +
        groupId +
        '">' +
        group.name +
        '</option>';
    });

    html += '<option value="new">+ Yeni gönderi</option>';

    if (select.innerHTML !== html) {
      select.innerHTML = html;
    }

    if (state.groups[current] || current === 'dealer') {
      select.value = current;
    } else {
      select.value = 'dealer';
      state.assignments[lineKey] = 'dealer';
      saveState();
    }
  }

  function productInfoForLine(lineKey) {
    const saved = state.lineMeta[lineKey] || {};

    const wrapper = document.querySelector(
      '.bigdora-shipment-selector[data-line-key="' +
        CSS.escape(lineKey) +
        '"]'
    );

    let title = saved.title || '';
    let variant = saved.variant || '';
    let image = saved.image || '';
    let url = saved.url || '';

    if (wrapper) {
      const row = wrapper.closest('.cart-items__table-row');
      const titleEl = row ? row.querySelector('.cart-items__title') : null;
      const imageEl = row ? row.querySelector('.cart-items__media-image') : null;

      title =
        wrapper.dataset.productTitle ||
        title ||
        (titleEl ? titleEl.textContent.trim() : '');

      variant = wrapper.dataset.variantTitle || variant;

      if (!variant && row) {
        const variants = row.querySelector('.cart-items__variants');

        if (variants) {
          variant = variants.textContent
            .replace(/\s+/g, ' ')
            .replace(/,\s*$/, '')
            .trim();
        }
      }

      image =
        wrapper.dataset.productImage ||
        image ||
        (imageEl ? (imageEl.currentSrc || imageEl.src || '') : '');

      url =
        wrapper.dataset.productUrl ||
        url ||
        (titleEl ? titleEl.getAttribute('href') || '' : '');
    }

    return {
      lineKey: lineKey,
      title: title || 'Ürün',
      variant: variant || '',
      image: image || '',
      url: url || '',
      unitPrice: parseInt(saved.unitPrice || 0, 10) || 0,
      linePrice: parseInt(saved.linePrice || 0, 10) || 0,
      quantity: parseInt(saved.quantity || 1, 10) || 1
    };
  }

  function getProductNameForLine(lineKey) {
    return productInfoForLine(lineKey).title;
  }

  function productsInGroup(groupId) {
    const products = [];

    Object.keys(state.assignments).forEach(function (lineKey) {
      if (state.assignments[lineKey] === groupId) {
        products.push(productInfoForLine(lineKey));
      }
    });

    return products;
  }

  function fulfillmentFeeForGroup(groupId) {
    let maxFee = 0;

    Object.keys(state.assignments).forEach(function (lineKey) {
      if (state.assignments[lineKey] !== groupId) return;

      let fee =
        state.lineMeta[lineKey] &&
        parseFloat(state.lineMeta[lineKey].fee || '0');

      if (!fee) {
        const wrapper = document.querySelector(
          '.bigdora-shipment-selector[data-line-key="' +
            CSS.escape(lineKey) +
            '"]'
        );

        if (wrapper) {
          fee = parseFloat(wrapper.dataset.ffBedel || '0') || 0;

          state.lineMeta[lineKey] = Object.assign(
            {},
            state.lineMeta[lineKey] || {},
            { fee: fee }
          );
        }
      }

      fee = parseFloat(fee || '0') || 0;

      if (fee > maxFee) {
        maxFee = fee;
      }
    });

    return maxFee;
  }

  function getFFConfig() {
    const el = document.getElementById('bigdora-ff-config');
    if (!el) return null;

    try {
      const parsed = JSON.parse(el.textContent || '{}');

      return {
        productId: parseInt(parsed.productId, 10) || 0,
        variants: parsed.variants || {}
      };
    } catch (e) {
      return null;
    }
  }

  function normalizeFeeKey(fee) {
    const num = parseFloat(fee || 0) || 0;
    if (Math.round(num) === num) return String(Math.round(num));
    return String(num);
  }

  function expectedFulfillmentLines() {
    const config = getFFConfig();

    if (!config || !config.productId) {
      return {
        ok: false,
        error: 'Fulfillment Hizmeti ürün yapılandırması bulunamadı.'
      };
    }

    const groups = [];
    const missing = [];

    sortedGroups().forEach(function (groupId) {
      const fee = fulfillmentFeeForGroup(groupId);
      if (fee <= 0) return;

      const feeKey = normalizeFeeKey(fee);
      const variantId = parseInt(config.variants[feeKey], 10) || 0;

      if (!variantId) {
        missing.push(feeKey);
        return;
      }

      const group = state.groups[groupId] || {};

      groups.push({
        groupId: groupId,
        name: group.name || ('Fulfillment ' + groupId),
        fee: fee,
        feeKey: feeKey,
        variantId: variantId,
        carrier: group.carrier || '',
        code: group.code || '',
        barcodeUrl: group.barcodeUrl || '',
        barcodeName: group.barcodeName || '',
        token: group.token || groupId
      });
    });

    if (missing.length) {
      return {
        ok: false,
        error:
          'Fulfillment Hizmeti ürününde şu fiyat varyantı bulunamadı: ' +
          missing.join(', ') +
          ' TL'
      };
    }

    return {
      ok: true,
      config: config,
      groups: groups
    };
  }

  function showFeeError(message) {
    document
      .querySelectorAll('.bigdora-shipment-fee-error')
      .forEach(function (el) {
        el.remove();
      });

    if (!message) return;

    const panel = document.querySelector('#bigdora-shipment-groups');
    if (!panel) return;

    const el = document.createElement('div');
    el.className = 'bigdora-shipment-fee-error';
    el.textContent = message;
    panel.prepend(el);
  }

  function refreshCartDrawer() {
    if (window.location.pathname === '/cart') {
      try {
        const overrideStep =
          sessionStorage.getItem(WIZARD_RESUME_OVERRIDE_KEY) || '';

        const resumeStep =
          overrideStep ||
          sessionStorage.getItem(WIZARD_STEP_KEY) ||
          'assign';

        sessionStorage.setItem(WIZARD_RESUME_ONCE_KEY, resumeStep);
        sessionStorage.removeItem(WIZARD_RESUME_OVERRIDE_KEY);
      } catch (e) {}

      window.location.reload();
      return Promise.resolve();
    }

    const SECTION_ID = 'cart-drawer-section';

    return fetch('/?sections=' + SECTION_ID, {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data[SECTION_ID]) return false;

        const liveDrawer = document.querySelector(
          'theme-drawer#cart-drawer'
        );

        if (!liveDrawer) return false;

        const holder = document.createElement('div');
        holder.innerHTML = String(data[SECTION_ID]).trim();

        const freshDrawer = holder.querySelector(
          'theme-drawer#cart-drawer'
        );

        if (!freshDrawer) return false;

        const liveItems = liveDrawer.querySelector(
          '.cart-items__wrapper'
        );

        const freshItems = freshDrawer.querySelector(
          '.cart-items__wrapper'
        );

        if (liveItems && freshItems) {
          liveItems.replaceWith(freshItems);
        }

        [
          '.cart__summary-totals',
          '.cart__subtotal-container',
          '.cart__total-container'
        ].forEach(function (selector) {
          const liveEl = liveDrawer.querySelector(selector);
          const freshEl = freshDrawer.querySelector(selector);

          if (liveEl && freshEl) {
            liveEl.replaceWith(freshEl);
          }
        });

        requestAnimationFrame(function () {
          hydrateShipmentStateFromCart().then(function () {
            renderAll();
          });
        });

        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function serviceLineProperties(group) {
    const props = {
      '_Bigdora FF Group': group.groupId,
      '_Bigdora FF Token': group.token || group.groupId,
      'Fulfillment Müşterisi': group.name,
      'Fulfillment Hizmet Bedeli': group.feeKey + ' TL'
    };

    if (group.carrier) {
      props['Kargo Firması'] = group.carrier;
    }

    if (group.code) {
      props['Kargo Takip Kodu'] = group.code;
    }

    if (group.barcodeUrl) {
      props['Kargo Barkodu'] = group.barcodeUrl;
    }

    return props;
  }

  function sameServiceMetadata(item, group) {
    const props = item.properties || {};

    if (String(props['_Bigdora FF Group'] || '') !== String(group.groupId)) {
      return false;
    }

    if (
      String(props['_Bigdora FF Token'] || '') !==
      String(group.token || group.groupId)
    ) {
      return false;
    }

    if (String(props['Fulfillment Müşterisi'] || '') !== String(group.name)) {
      return false;
    }

    if (String(props['Fulfillment Hizmet Bedeli'] || '') !== String(group.feeKey + ' TL')) {
      return false;
    }

    if (String(props['Kargo Firması'] || '') !== String(group.carrier || '')) {
      return false;
    }

    if (String(props['Kargo Takip Kodu'] || '') !== String(group.code || '')) {
      return false;
    }

    return true;
  }

  function syncFulfillmentFees() {
    if (ffSyncRunning) return Promise.resolve(false);

    const wanted = expectedFulfillmentLines();

    if (!wanted.ok) {
      showFeeError(wanted.error);
      return Promise.resolve(false);
    }

    showFeeError('');
    ffSyncRunning = true;

    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return false;

        const serviceItems = cart.items.filter(function (item) {
          return item.product_id === wanted.config.productId;
        });

        const expectedByGroup = {};
        wanted.groups.forEach(function (group) {
          expectedByGroup[group.groupId] = group;
        });

        let chain = Promise.resolve();
        let changed = false;

        serviceItems.forEach(function (item) {
          const groupId = String(
            (item.properties && item.properties['_Bigdora FF Group']) || ''
          );

          const expectedGroup = expectedByGroup[groupId];

          if (
            !expectedGroup ||
            parseInt(item.variant_id, 10) !== parseInt(expectedGroup.variantId, 10)
          ) {
            changed = true;

            chain = chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              }).then(function (r) {
                if (!r.ok) throw new Error('Eski fulfillment satırı silinemedi');
                return r.json();
              });
            });
          }
        });

        wanted.groups.forEach(function (group) {
          const existing = serviceItems.find(function (item) {
            const props = item.properties || {};

            return (
              String(props['_Bigdora FF Group'] || '') === String(group.groupId) &&
              parseInt(item.variant_id, 10) === parseInt(group.variantId, 10)
            );
          });

          if (!existing) {
            changed = true;

            chain = chain.then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: group.variantId,
                      quantity: 1,
                      properties: serviceLineProperties(group)
                    }
                  ]
                })
              }).then(function (r) {
                if (!r.ok) throw new Error('Fulfillment hizmeti eklenemedi');
                return r.json();
              });
            });

            return;
          }

          if (existing.quantity !== 1 || !sameServiceMetadata(existing, group)) {
            changed = true;

            chain = chain.then(function () {
              const props = serviceLineProperties(group);

              if (
                existing.properties &&
                existing.properties['Kargo Barkodu'] &&
                !props['Kargo Barkodu']
              ) {
                props['Kargo Barkodu'] = existing.properties['Kargo Barkodu'];
              }

              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json'
                },
                body: JSON.stringify({
                  id: existing.key,
                  quantity: 1,
                  properties: props
                })
              }).then(function (r) {
                if (!r.ok) throw new Error('Fulfillment hizmeti güncellenemedi');
                return r.json();
              });
            });
          }
        });

        return chain.then(function () {
          return changed;
        });
      })
      .then(function (changed) {
        ffSyncRunning = false;

        if (changed) {
          return refreshCartDrawer().then(function () {
            return true;
          });
        }

        return false;
      })
      .catch(function () {
        ffSyncRunning = false;

        showFeeError(
          'Fulfillment hizmet bedeli sepete eklenirken bir sorun oluştu.'
        );

        return false;
      });
  }

  function scheduleFulfillmentSync(delay) {
    clearTimeout(ffSyncTimer);

    ffSyncTimer = setTimeout(function () {
      syncFulfillmentFees();
    }, typeof delay === 'number' ? delay : 250);
  }


  function publicProperties(item) {
    const props = {};
    const current = item && item.properties ? item.properties : {};

    Object.keys(current).forEach(function (key) {
      props[key] = current[key];
    });

    return props;
  }

  function groupNameById(groupId) {
    if (groupId === 'dealer') return 'Size gelecek';

    if (state.groups[groupId]) {
      return state.groups[groupId].name;
    }

    return '';
  }

  function replaceAssignmentKey(oldKey, newKey) {
    if (!oldKey || !newKey || oldKey === newKey) return;

    if (Object.prototype.hasOwnProperty.call(state.assignments, oldKey)) {
      state.assignments[newKey] = state.assignments[oldKey];
      delete state.assignments[oldKey];
    }

    if (state.lineMeta[oldKey]) {
      state.lineMeta[newKey] = state.lineMeta[oldKey];
      delete state.lineMeta[oldKey];
    }

    saveState();

    const wrapper = document.querySelector(
      '.bigdora-shipment-selector[data-line-key="' +
        CSS.escape(oldKey) +
        '"]'
    );

    if (wrapper) {
      wrapper.dataset.lineKey = newKey;

      const row = wrapper.closest('.cart-items__table-row');

      if (row) {
        row.dataset.key = newKey;

        if (row.id && row.id.indexOf('CartItem-') === 0) {
          row.id = 'CartItem-' + newKey;
        }
      }
    }
  }

  function persistLineAssignment(lineKey, groupId) {
    const groupName = groupNameById(groupId);
    if (!groupName) return Promise.resolve(false);

    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return false;

        const item = cart.items.find(function (x) {
          return x.key === lineKey;
        });

        if (!item) return false;

        const props = publicProperties(item);

        const wrapper = document.querySelector(
          '.bigdora-shipment-selector[data-line-key="' +
            CSS.escape(lineKey) +
            '"]'
        );

        const storedMeta = state.lineMeta[lineKey] || {};
        const ffFee =
          parseFloat(
            (wrapper && wrapper.dataset.ffBedel) ||
            storedMeta.fee ||
            props['_Bigdora FF Bedel'] ||
            '0'
          ) || 0;

        if (!state.lineMeta[lineKey]) state.lineMeta[lineKey] = {};
        state.lineMeta[lineKey].fee = ffFee;

        if (ffFee > 0) {
          props['_Bigdora FF Bedel'] = String(ffFee);
        }

        if (groupId === 'dealer') {
          props['Gönderi'] = 'Size gelecek';
          delete props['Fulfillment Müşterisi'];
          delete props['Kargo Firması'];
          delete props['Kargo Takip Kodu'];
        } else {
          const group = state.groups[groupId];

          props['Gönderi'] = groupName;
          props['Fulfillment Müşterisi'] = groupName;

          if (group && group.carrier) {
            props['Kargo Firması'] = group.carrier;
          } else {
            delete props['Kargo Firması'];
          }

          if (group && group.code) {
            props['Kargo Takip Kodu'] = group.code;
          } else {
            delete props['Kargo Takip Kodu'];
          }
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: item.quantity,
            properties: props
          })
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (updatedCart) {
            if (!updatedCart || !updatedCart.items) return false;

            const candidate = updatedCart.items.find(function (x) {
              if (x.variant_id !== item.variant_id) return false;

              const p = x.properties || {};
              return p['Gönderi'] === groupName;
            });

            if (candidate) {
              replaceAssignmentKey(lineKey, candidate.key);
              return candidate.key;
            }

            return lineKey;
          });
      })
      .catch(function () {
        return false;
      });
  }

  function updateCartAttributesForGroup(groupId) {
    if (!state.groups[groupId]) return Promise.resolve(false);

    const group = state.groups[groupId];
    const attrs = {};

    attrs[group.name + ' - Kargo Firması'] = group.carrier || '';
    attrs[group.name + ' - Kargo Takip Kodu'] = group.code || '';

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: attrs
      })
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        return !!cart;
      })
      .catch(function () {
        return false;
      });
  }

  function persistGroupMetadata(groupId) {
    const group = state.groups[groupId];
    if (!group) return Promise.resolve(false);

    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return false;

        const matching = cart.items.filter(function (item) {
          const props = item.properties || {};
          return props['Fulfillment Müşterisi'] === group.name ||
            props['Gönderi'] === group.name;
        });

        let chain = Promise.resolve();

        matching.forEach(function (item) {
          chain = chain.then(function () {
            const props = publicProperties(item);

            props['Gönderi'] = group.name;
            props['Fulfillment Müşterisi'] = group.name;

            if (group.carrier) {
              props['Kargo Firması'] = group.carrier;
            } else {
              delete props['Kargo Firması'];
            }

            if (group.code) {
              props['Kargo Takip Kodu'] = group.code;
            } else {
              delete props['Kargo Takip Kodu'];
            }

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties: props
              })
            }).then(function (r) {
              return r.ok ? r.json() : null;
            });
          });
        });

        return chain.then(function () {
          return updateCartAttributesForGroup(groupId);
        });
      })
      .catch(function () {
        return false;
      });
  }


  function findServiceLineForGroup(cart, groupId) {
    const config = getFFConfig();
    if (!cart || !cart.items || !config) return null;

    return cart.items.find(function (item) {
      const props = item.properties || {};

      const group = state.groups[groupId] || {};
      const tokenMatches =
        !group.token ||
        String(props['_Bigdora FF Token'] || '') === String(group.token);

      return (
        item.product_id === config.productId &&
        String(props['_Bigdora FF Group'] || '') === String(groupId) &&
        tokenMatches
      );
    }) || null;
  }

  function uploadBarcodeForGroup(groupId, file) {
    if (!file || !state.groups[groupId]) {
      return Promise.resolve(false);
    }

    const group = state.groups[groupId];
    const wanted = expectedFulfillmentLines();

    if (!wanted.ok) {
      showFeeError(wanted.error);
      return Promise.resolve(false);
    }

    const expectedGroup = wanted.groups.find(function (x) {
      return x.groupId === groupId;
    });

    if (!expectedGroup) {
      showFeeError('Bu gönderi için fulfillment hizmet bedeli bulunamadı.');
      return Promise.resolve(false);
    }

    group.barcodeName = file.name;
    group.barcodeUploading = true;
    saveState();
    renderGroups();

    return syncFulfillmentFees()
      .then(function () {
        return fetch('/cart.js', {
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) throw new Error('Sepet okunamadı');

        const oldLine = findServiceLineForGroup(cart, groupId);

        const formData = new FormData();
        formData.append('id', String(expectedGroup.variantId));
        formData.append('quantity', '1');

        formData.append(
          'properties[_Bigdora FF Group]',
          expectedGroup.groupId
        );
        formData.append(
          'properties[_Bigdora FF Token]',
          expectedGroup.token || expectedGroup.groupId
        );
        formData.append(
          'properties[Fulfillment Müşterisi]',
          expectedGroup.name
        );
        formData.append(
          'properties[Fulfillment Hizmet Bedeli]',
          expectedGroup.feeKey + ' TL'
        );

        if (expectedGroup.carrier) {
          formData.append(
            'properties[Kargo Firması]',
            expectedGroup.carrier
          );
        }

        if (expectedGroup.code) {
          formData.append(
            'properties[Kargo Takip Kodu]',
            expectedGroup.code
          );
        }

        formData.append(
          'properties[Kargo Barkodu]',
          file,
          file.name
        );

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        })
          .then(function (r) {
            if (!r.ok) {
              throw new Error('Kargo barkodu Shopify’a yüklenemedi');
            }

            return r.json();
          })
          .then(function () {
            if (!oldLine) return null;

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: oldLine.key,
                quantity: 0
              })
            }).then(function (r) {
              if (!r.ok) throw new Error('Eski hizmet satırı kaldırılamadı');
              return r.json();
            });
          });
      })
      .then(function () {
        return fetch('/cart.js', {
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        const newLine = findServiceLineForGroup(cart, groupId);
        const props = newLine && newLine.properties ? newLine.properties : {};
        const url = props['Kargo Barkodu'] || '';

        group.barcodeUploading = false;
        group.barcodeUrl = url;
        group.barcodeName = file.name;
        saveState();

        return updateCartAttributesForGroup(groupId).then(function () {
          return refreshCartDrawer();
        });
      })
      .then(function () {
        renderAll();
        return true;
      })
      .catch(function (err) {
        group.barcodeUploading = false;
        saveState();
        renderGroups();

        showFeeError(
          err && err.message
            ? err.message
            : 'Kargo barkodu yüklenirken bir sorun oluştu.'
        );

        return false;
      });
  }

  function createPanel() {
    const cartItems = document.querySelector('.cart-items');

    if (!cartItems) return null;

    let panel = cartItems.querySelector('#bigdora-shipment-groups');

    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'bigdora-shipment-groups';
      panel.className = 'bigdora-shipment-groups';

      const table = cartItems.querySelector('.cart-items__table');

      if (table) {
        table.insertAdjacentElement('beforebegin', panel);
      } else {
        cartItems.prepend(panel);
      }
    }

    return panel;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function groupMissingFields(groupId) {
    const group = state.groups[groupId] || {};
    const missing = [];

    if (!group.carrier) {
      missing.push('Kargo firması');
    }

    const hasTrackingCode = !!String(group.code || '').trim();
    const hasBarcode = !!group.barcodeUrl;

    if (!hasTrackingCode && !hasBarcode) {
      missing.push('Kargo takip kodu veya kargo barkodu');
    }

    return missing;
  }


  /* =========================================================
     BIGDORA v4.0 / CART WIZARD
     Yalnızca /cart sayfasında çalışır.
     Drawer tarafında v3.0 kart yapısı korunur.
     ========================================================= */

  function wizardGetCurrentKey() {
    try {
      return sessionStorage.getItem(WIZARD_STEP_KEY) || 'assign';
    } catch (e) {
      return 'assign';
    }
  }

  function wizardSetCurrentKey(key) {
    try {
      sessionStorage.setItem(WIZARD_STEP_KEY, key || 'assign');
    } catch (e) {}
  }

  function wizardSteps() {
    const steps = [
      { key: 'assign', type: 'assign', title: 'Ürünleri Ayır' },
      { key: 'dealer', type: 'dealer', title: 'Size Gelecekler' }
    ];

    sortedGroups().forEach(function (groupId) {
      const group = state.groups[groupId];

      steps.push({
        key: groupId,
        type: 'group',
        groupId: groupId,
        title: group ? group.name : groupId
      });
    });

    steps.push({
      key: 'review',
      type: 'review',
      title: 'Sipariş Kontrolü'
    });

    return steps;
  }

  function wizardCurrentStep() {
    const steps = wizardSteps();
    const wantedKey = wizardGetCurrentKey();

    const found = steps.find(function (step) {
      return step.key === wantedKey;
    });

    if (found) return found;

    wizardSetCurrentKey('assign');
    return steps[0];
  }

  function wizardStepIndex(step) {
    const steps = wizardSteps();

    return Math.max(
      0,
      steps.findIndex(function (item) {
        return item.key === step.key;
      })
    );
  }

  function wizardGroupComplete(groupId) {
    return groupMissingFields(groupId).length === 0;
  }

  function wizardAllGroupsComplete() {
    return sortedGroups().every(function (groupId) {
      return wizardGroupComplete(groupId);
    });
  }

  function wizardAssignedLineKeys(groupId) {
    return Object.keys(state.assignments).filter(function (lineKey) {
      return state.assignments[lineKey] === groupId;
    });
  }

  function wizardNormalLineKeys() {
    return Object.keys(state.lineMeta || {}).filter(function (lineKey) {
      return Object.prototype.hasOwnProperty.call(state.assignments, lineKey);
    });
  }

  function wizardAssignmentOptions(current) {
    let html =
      '<option value="dealer"' +
      (current === 'dealer' ? ' selected' : '') +
      '>Size gelecek</option>';

    sortedGroups().forEach(function (groupId) {
      const group = state.groups[groupId];

      html +=
        '<option value="' +
        escapeHtml(groupId) +
        '"' +
        (current === groupId ? ' selected' : '') +
        '>' +
        escapeHtml(group ? group.name : groupId) +
        '</option>';
    });

    html += '<option value="new">+ Yeni fulfillment müşterisi</option>';

    return html;
  }

  function wizardFormatMoney(cents) {
    const amount = (parseInt(cents || 0, 10) || 0) / 100;

    return amount.toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' TL';
  }

  function wizardProductCard(lineKey, editable) {
    const product = productInfoForLine(lineKey);
    const current = state.assignments[lineKey] || 'dealer';
    const displayPrice =
      product.linePrice ||
      (product.unitPrice * Math.max(1, product.quantity || 1));

    return (
      '<article class="bdw-product-card">' +
        (product.image
          ? '<img class="bdw-product-image" src="' +
              escapeHtml(product.image) +
              '" alt="">'
          : '<div class="bdw-product-image bdw-product-image--empty"></div>') +
        '<div class="bdw-product-copy">' +
          '<strong>' + escapeHtml(product.title) + '</strong>' +
          '<div class="bdw-product-meta">' +
            (product.variant
              ? '<span class="bdw-product-variant">' +
                  escapeHtml(product.variant) +
                '</span>'
              : '') +
            '<span class="bdw-product-price">' +
              escapeHtml(wizardFormatMoney(displayPrice)) +
            '</span>' +
            (product.quantity > 1
              ? '<span class="bdw-product-qty">' +
                  escapeHtml(String(product.quantity)) +
                  ' adet</span>'
              : '') +
          '</div>' +
        '</div>' +
        (editable
          ? '<label class="bdw-product-select">' +
              '<span>Gönderi</span>' +
              '<select data-wizard-assignment="' +
                escapeHtml(lineKey) +
              '">' +
                wizardAssignmentOptions(current) +
              '</select>' +
            '</label>'
          : '') +
      '</article>'
    );
  }

  function wizardStepStatus(step) {
    if (step.type === 'group') {
      return wizardGroupComplete(step.groupId) ? 'complete' : 'incomplete';
    }

    if (step.type === 'review') {
      return wizardAllGroupsComplete() ? 'complete' : 'incomplete';
    }

    return 'ready';
  }

  function wizardTabs(currentStep) {
    const steps = wizardSteps();

    return (
      '<nav class="bdw-tabs" aria-label="Sipariş adımları">' +
        steps
          .map(function (step, index) {
            const active = step.key === currentStep.key;
            const status = wizardStepStatus(step);

            return (
              '<button type="button" class="bdw-tab' +
                (active ? ' is-active' : '') +
                (status === 'complete' ? ' is-complete' : '') +
                (status === 'incomplete' ? ' is-incomplete' : '') +
              '" data-wizard-goto="' +
                escapeHtml(step.key) +
              '">' +
                '<span class="bdw-tab-no">' +
                  (status === 'complete' && !active ? '✓' : String(index + 1)) +
                '</span>' +
                '<span>' + escapeHtml(step.title) + '</span>' +
              '</button>'
            );
          })
          .join('') +
      '</nav>'
    );
  }

  function wizardIntro(title, text) {
    return (
      '<div class="bdw-intro">' +
        '<strong>' + escapeHtml(title) + '</strong>' +
        '<span>' + escapeHtml(text) + '</span>' +
      '</div>'
    );
  }

  function wizardRenderAssign() {
    const lineKeys = wizardNormalLineKeys();

    return (
      wizardIntro(
        'Ürünlerin gönderileceği yeri belirleyin.',
        'Her ürünü kendinize veya farklı fulfillment müşterilerine ayırabilirsiniz.'
      ) +
      (lineKeys.length
        ? '<div class="bdw-products">' +
            lineKeys
              .map(function (lineKey) {
                return wizardProductCard(lineKey, true);
              })
              .join('') +
          '</div>'
        : '<div class="bdw-empty">Sepette ürün bulunmuyor.</div>')
    );
  }

  function wizardRenderDealer() {
    const lineKeys = wizardAssignedLineKeys('dealer');

    return (
      wizardIntro(
        'Size gelecek ürünleri kontrol edin.',
        'Bu ürünler doğrudan bayi siparişiniz olarak size gönderilecek.'
      ) +
      (lineKeys.length
        ? '<div class="bdw-products">' +
            lineKeys
              .map(function (lineKey) {
                return wizardProductCard(lineKey, true);
              })
              .join('') +
          '</div>'
        : '<div class="bdw-empty">Bana gelsin grubunda ürün bulunmuyor. Bu adımı geçebilirsiniz.</div>')
    );
  }

  function wizardCarrierOptions(selected) {
    const carriers = [
      'Aras Kargo',
      'Yurtiçi Kargo',
      'MNG Kargo',
      'Sürat Kargo',
      'PTT Kargo',
      'Sendeo',
      'Kolay Gelsin',
      'HepsiJET',
      'Trendyol Express',
      'Scotty',
      'UPS',
      'DHL',
      'FedEx',
      'Diğer'
    ];

    let html = '<option value="">Kargo firması seçin</option>';

    carriers.forEach(function (carrier) {
      html +=
        '<option value="' +
        escapeHtml(carrier) +
        '"' +
        (selected === carrier ? ' selected' : '') +
        '>' +
        escapeHtml(carrier) +
        '</option>';
    });

    return html;
  }

  function wizardRenderGroup(groupId) {
    const group = state.groups[groupId];
    if (!group) {
      wizardSetCurrentKey('assign');
      return wizardRenderAssign();
    }

    const lineKeys = wizardAssignedLineKeys(groupId);
    const fee = fulfillmentFeeForGroup(groupId);
    const missing = groupMissingFields(groupId);

    return (
      wizardIntro(
        group.name + ' gönderisini tamamlayın.',
        'Ürünleri kontrol edin; kargo firması zorunludur. Takip kodu veya barkoddan en az biri yeterlidir.'
      ) +

      '<div class="bdw-group-head">' +
        '<div class="bdw-group-state ' +
          (missing.length ? 'is-incomplete' : 'is-complete') +
        '">' +
          '<span>' + (missing.length ? '!' : '✓') + '</span>' +
          '<div>' +
            '<strong>' +
              (missing.length ? 'Gönderi bilgileri eksik' : 'Gönderi hazır') +
            '</strong>' +
            '<small>' +
              (missing.length
                ? escapeHtml(missing.join(' · '))
                : 'Kargo bilgileri tamamlandı') +
            '</small>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="bdw-link-button" data-delete-shipment="' +
          escapeHtml(groupId) +
        '">Gönderiyi kaldır</button>' +
      '</div>' +

      (lineKeys.length
        ? '<div class="bdw-products bdw-products--group">' +
            lineKeys
              .map(function (lineKey) {
                return wizardProductCard(lineKey, true);
              })
              .join('') +
          '</div>'
        : '<div class="bdw-empty">Bu müşteriye atanmış ürün bulunmuyor.</div>') +

      '<div class="bdw-fee-row">' +
        '<span>Fulfillment hizmet bedeli</span>' +
        '<strong>' +
          fee.toLocaleString('tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }) +
        ' TL</strong>' +
      '</div>' +

      '<div class="bdw-form-grid">' +
        '<label class="bdw-field">' +
          '<span>Kargo firması <b>*</b></span>' +
          '<select data-shipment-carrier="' + escapeHtml(groupId) + '">' +
            wizardCarrierOptions(group.carrier || '') +
          '</select>' +
        '</label>' +

        '<label class="bdw-field">' +
          '<span>Kargo kodu / takip numarası</span>' +
          '<input type="text" data-shipment-code="' +
            escapeHtml(groupId) +
            '" value="' +
            escapeHtml(group.code || '') +
            '" placeholder="Kargo kodunu girin">' +
          '<small>Takip kodu veya barkoddan en az biri zorunlu.</small>' +
        '</label>' +

        '<label class="bdw-field bdw-field--barcode">' +
          '<span>Kargo barkodu / etiketi</span>' +
          '<input type="file" data-shipment-barcode="' +
            escapeHtml(groupId) +
            '" accept=".pdf,.jpg,.jpeg,.png,.webp">' +
          '<small class="' +
            (group.barcodeUrl ? 'is-success' : '') +
          '">' +
            (group.barcodeUploading
              ? 'Yükleniyor...'
              : group.barcodeUrl
                ? '✓ Yüklendi: ' +
                  escapeHtml(group.barcodeName || 'Kargo barkodu')
                : 'PDF/görsel · en fazla 20 MB · takip kodu ile birlikte de eklenebilir') +
          '</small>' +
        '</label>' +
      '</div>'
    );
  }

  function wizardReviewCard(title, count, complete, details, gotoKey) {
    return (
      '<article class="bdw-review-card ' +
        (complete ? 'is-complete' : 'is-incomplete') +
      '">' +
        '<div class="bdw-review-icon">' + (complete ? '✓' : '!') + '</div>' +
        '<div class="bdw-review-copy">' +
          '<strong>' + escapeHtml(title) + '</strong>' +
          '<span>' + count + ' ürün</span>' +
          (details
            ? '<small>' + escapeHtml(details) + '</small>'
            : '') +
        '</div>' +
        '<button type="button" class="bdw-review-edit" data-wizard-goto="' +
          escapeHtml(gotoKey) +
        '">Düzenle</button>' +
      '</article>'
    );
  }

  function wizardRenderReview() {
    let html = wizardIntro(
      'Siparişinizi son kez kontrol edin.',
      'Tüm fulfillment gönderileri tamamlandıysa ödeme adımına geçebilirsiniz.'
    );

    html += '<div class="bdw-review-list">';

    html += wizardReviewCard(
      'Size Gelecekler',
      wizardAssignedLineKeys('dealer').length,
      true,
      '',
      'dealer'
    );

    sortedGroups().forEach(function (groupId) {
      const group = state.groups[groupId];
      const complete = wizardGroupComplete(groupId);
      const details = [];

      if (group.carrier) details.push(group.carrier);
      if (group.code) details.push('Takip: ' + group.code);
      if (group.barcodeUrl) details.push('Barkod yüklendi');

      html += wizardReviewCard(
        group.name,
        wizardAssignedLineKeys(groupId).length,
        complete,
        details.join(' · '),
        groupId
      );
    });

    html += '</div>';

    if (!wizardAllGroupsComplete()) {
      html +=
        '<div class="bdw-review-warning">' +
          '<strong>Ödeme için eksik gönderiler var.</strong>' +
          '<span>Kırmızı işaretli fulfillment müşterilerini tamamlayın.</span>' +
        '</div>';
    }

    return html;
  }

  function wizardStepBody(step) {
    if (step.type === 'assign') return wizardRenderAssign();
    if (step.type === 'dealer') return wizardRenderDealer();
    if (step.type === 'group') return wizardRenderGroup(step.groupId);
    return wizardRenderReview();
  }

  function wizardFooter(step) {
    const steps = wizardSteps();
    const index = wizardStepIndex(step);
    const isFirst = index === 0;
    const isLast = index === steps.length - 1;

    let nextText = 'Onayla ve Devam Et';

    if (step.type === 'assign') nextText = wizardCommitRunning ? 'Kaydediliyor...' : 'Ürünleri Ayırdım';
    if (step.type === 'dealer') nextText = 'Bu Grubu Onayla';
    if (step.type === 'group') nextText = 'Gönderiyi Onayla';
    if (step.type === 'review') {
      nextText = 'Siparişi Onayla ve Ödemeye Geç';
    }

    return (
      '<footer class="bdw-footer">' +
        '<button type="button" class="bdw-button bdw-button--ghost" data-wizard-prev' +
          (isFirst ? ' disabled' : '') +
        '>← Geri</button>' +
        '<button type="button" class="bdw-button bdw-button--primary" ' +
          (isLast ? 'data-wizard-checkout' : 'data-wizard-next') +
        '>' +
          escapeHtml(nextText) +
        '</button>' +
      '</footer>'
    );
  }

  function renderWizard() {
    if (!IS_CART_PAGE) return;

    const panel = createPanel();
    if (!panel) return;

    document.documentElement.classList.add('bigdora-wizard-v4-active');

    const step = wizardCurrentStep();
    const steps = wizardSteps();
    const index = wizardStepIndex(step);
    const progress = Math.round(((index + 1) / steps.length) * 100);

    panel.style.display = '';
    panel.className = 'bigdora-shipment-groups bdw-root';

    panel.innerHTML =
      '<section class="bdw-shell">' +
        '<header class="bdw-header">' +
          '<div>' +
            '<div class="bdw-eyebrow">BİGDORA SİPARİŞ HAZIRLAMA</div>' +
            '<h2>' + escapeHtml(step.title) + '</h2>' +
            '<p>Adım ' + (index + 1) + ' / ' + steps.length + '</p>' +
          '</div>' +
          '<div class="bdw-progress-wrap">' +
            '<span>' + progress + '%</span>' +
            '<div class="bdw-progress"><i style="width:' + progress + '%"></i></div>' +
          '</div>' +
        '</header>' +

        wizardTabs(step) +

        '<div class="bdw-body">' +
          wizardStepBody(step) +
        '</div>' +

        wizardFooter(step) +
      '</section>';
  }

  function wizardGoTo(key) {
    const exists = wizardSteps().some(function (step) {
      return step.key === key;
    });

    wizardSetCurrentKey(exists ? key : 'assign');
    renderWizard();

    const panel = document.querySelector('#bigdora-shipment-groups');

    if (panel) {
      panel.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  function wizardGoRelative(delta) {
    const step = wizardCurrentStep();
    const steps = wizardSteps();
    const index = wizardStepIndex(step);
    const nextIndex = Math.max(
      0,
      Math.min(steps.length - 1, index + delta)
    );

    wizardGoTo(steps[nextIndex].key);
  }

  function wizardShowError(message) {
    const body = document.querySelector('.bdw-body');
    if (!body) {
      alert(message);
      return;
    }

    body
      .querySelectorAll('.bdw-error')
      .forEach(function (el) {
        el.remove();
      });

    const box = document.createElement('div');
    box.className = 'bdw-error';
    box.innerHTML =
      '<strong>Eksik bilgi</strong>' +
      '<span>' + escapeHtml(message) + '</span>';

    body.prepend(box);

    box.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  function wizardHandleAssignment(lineKey, rawValue) {
    let value = rawValue;

    if (!lineKey || wizardCommitRunning) return;

    if (value === 'new') {
      value = createGroup();
    }

    /*
      v4.3:
      Ürün ayırma ekranında her seçim Shopify'a anında yazılmaz.
      Kullanıcı bütün ürünleri ayırır, "Ürünleri Ayırdım" dediğinde
      tüm satırlar tek akışta kaydedilir ve fulfillment ücretleri bir kez sync edilir.
    */
    state.assignments[lineKey] = value;
    cleanupGroups();
    saveState();
    wizardAssignmentsDirty = true;
    renderWizard();
  }

  function wizardCommitAssignments() {
    if (wizardCommitRunning) return Promise.resolve(false);

    wizardCommitRunning = true;
    renderWizard();

    const assignments = Object.keys(state.assignments).map(function (lineKey) {
      return {
        lineKey: lineKey,
        groupId: state.assignments[lineKey] || 'dealer'
      };
    });

    let chain = Promise.resolve();

    assignments.forEach(function (assignment) {
      chain = chain.then(function () {
        /*
          Önceki satırın key'i başka bir persist işleminde değişmiş olabilir.
          replaceAssignmentKey state'i güncellediği için, eski key state'te yoksa
          aynı metadata/variant üzerinden yaşayan key'i bulmaya çalışıyoruz.
        */
        let liveKey = assignment.lineKey;

        if (!state.assignments[liveKey]) {
          const oldMeta = state.lineMeta[assignment.lineKey] || {};
          const candidate = Object.keys(state.lineMeta).find(function (key) {
            const meta = state.lineMeta[key] || {};
            return (
              meta.variantId &&
              oldMeta.variantId &&
              String(meta.variantId) === String(oldMeta.variantId) &&
              state.assignments[key] === assignment.groupId
            );
          });

          if (candidate) liveKey = candidate;
        }

        return persistLineAssignment(liveKey, assignment.groupId);
      });
    });

    return chain
      .then(function () {
        wizardAssignmentsDirty = false;

        /*
          Ürün ayırma sonrası fulfillment hizmet satırı eklenmesi /cart reload
          oluşturursa reload'dan sonra "Size Gelecekler" adımından devam et.
        */
        if (IS_CART_PAGE) {
          try {
            sessionStorage.setItem(
              WIZARD_RESUME_OVERRIDE_KEY,
              'dealer'
            );
          } catch (e) {}
        }

        return syncFulfillmentFees();
      })
      .then(function () {
        wizardCommitRunning = false;

        /*
          Reload oluşmadıysa override kullanılmamıştır; temizleyip doğrudan
          ikinci adıma geçiyoruz.
        */
        if (IS_CART_PAGE) {
          try {
            sessionStorage.removeItem(WIZARD_RESUME_OVERRIDE_KEY);
          } catch (e) {}

          wizardGoTo('dealer');
        }

        return true;
      })
      .catch(function () {
        wizardCommitRunning = false;
        renderWizard();
        wizardShowError(
          'Ürün gönderileri kaydedilirken bir sorun oluştu. Lütfen tekrar deneyin.'
        );
        return false;
      });
  }

  function wizardCheckout() {
    if (!wizardAllGroupsComplete()) {
      wizardShowError(
        'Ödemeye geçmeden önce tüm fulfillment gönderilerinde kargo firması ve takip kodu veya barkod bilgisini tamamlayın.'
      );
      return;
    }

    if (!validateFulfillmentBeforeCheckout()) {
      return;
    }

    const nativeCheckout =
      document.querySelector('.cart__checkout-button') ||
      document.querySelector('[name="checkout"]') ||
      document.querySelector('a[href*="/checkout"]');

    if (!nativeCheckout) {
      wizardShowError(
        'Ödeme butonu bulunamadı. Sayfayı yenileyip tekrar deneyin.'
      );
      return;
    }

    nativeCheckout.click();
  }

  document.addEventListener('change', function (event) {
    if (!IS_CART_PAGE) return;

    if (event.target.matches('[data-wizard-assignment]')) {
      const lineKey = event.target.dataset.wizardAssignment;
      const value = event.target.value;

      wizardHandleAssignment(lineKey, value);
    }
  });

  document.addEventListener('click', function (event) {
    if (!IS_CART_PAGE) return;

    const goto = event.target.closest('[data-wizard-goto]');
    if (goto) {
      event.preventDefault();

      const current = wizardCurrentStep();
      const targetKey = goto.dataset.wizardGoto;

      if (
        current.type === 'assign' &&
        targetKey !== 'assign' &&
        wizardAssignmentsDirty
      ) {
        wizardCommitAssignments().then(function (ok) {
          if (ok && targetKey !== 'dealer') {
            wizardGoTo(targetKey);
          }
        });
        return;
      }

      wizardGoTo(targetKey);
      return;
    }

    const prev = event.target.closest('[data-wizard-prev]');
    if (prev) {
      event.preventDefault();
      wizardGoRelative(-1);
      return;
    }

    const next = event.target.closest('[data-wizard-next]');
    if (next) {
      event.preventDefault();

      const step = wizardCurrentStep();

      if (step.type === 'assign') {
        wizardCommitAssignments();
        return;
      }

      if (step.type === 'group' && !wizardGroupComplete(step.groupId)) {
        wizardShowError(
          'Bu gönderiyi onaylamak için kargo firması seçin ve takip kodu veya barkoddan en az birini ekleyin.'
        );
        return;
      }

      if (step.type === 'group') {
        persistGroupMetadata(step.groupId).then(function () {
          wizardGoRelative(1);
        });
      } else {
        wizardGoRelative(1);
      }

      return;
    }

    const checkout = event.target.closest('[data-wizard-checkout]');
    if (checkout) {
      event.preventDefault();
      wizardCheckout();
    }
  });

  function injectWizardStyles() {
    if (!IS_CART_PAGE) return;
    if (document.getElementById('bigdora-wizard-v4-styles')) return;

    const style = document.createElement('style');
    style.id = 'bigdora-wizard-v4-styles';

    style.textContent = `
      html.bigdora-wizard-v4-active .cart-items__table{
        display:none !important;
      }

      html.bigdora-wizard-v4-active .cart__checkout-button,
      html.bigdora-wizard-v4-active [name="checkout"]{
        display:none !important;
      }

      html.bigdora-wizard-v4-active #bigdora-shipment-groups.bdw-root{
        display:block !important;
        width:100%;
        margin:0 0 22px;
        padding:0;
        border:0;
      }

      .bdw-shell{
        width:100%;
        overflow:hidden;
        border:1px solid rgba(0,0,0,.11);
        border-radius:15px;
        background:#fff;
      }

      .bdw-header{
        display:flex;
        align-items:flex-end;
        justify-content:space-between;
        gap:22px;
        padding:22px 20px 18px;
        border-bottom:1px solid rgba(0,0,0,.08);
      }

      .bdw-eyebrow{
        margin-bottom:7px;
        font-size:9px;
        letter-spacing:.18em;
        opacity:.55;
      }

      .bdw-header h2{
        margin:0;
        font-size:23px;
        line-height:1.12;
      }

      .bdw-header p{
        margin:6px 0 0;
        font-size:10px;
        opacity:.55;
      }

      .bdw-progress-wrap{
        width:170px;
        max-width:34%;
      }

      .bdw-progress-wrap > span{
        display:block;
        margin-bottom:6px;
        text-align:right;
        font-size:9px;
        opacity:.55;
      }

      .bdw-progress{
        height:4px;
        overflow:hidden;
        border-radius:999px;
        background:rgba(0,0,0,.08);
      }

      .bdw-progress i{
        display:block;
        height:100%;
        border-radius:inherit;
        background:#111;
        transition:width .2s ease;
      }

      .bdw-tabs{
        display:flex;
        gap:7px;
        overflow-x:auto;
        padding:11px 14px;
        border-bottom:1px solid rgba(0,0,0,.08);
        scrollbar-width:none;
      }

      .bdw-tabs::-webkit-scrollbar{
        display:none;
      }

      .bdw-tab{
        display:inline-flex;
        align-items:center;
        gap:7px;
        flex:0 0 auto;
        min-height:34px;
        padding:6px 10px;
        border:1px solid rgba(0,0,0,.11);
        border-radius:999px;
        background:#fff;
        color:#111;
        font:inherit;
        font-size:10px;
        cursor:pointer;
      }

      .bdw-tab.is-active{
        border-color:#111;
        background:#111;
        color:#fff;
      }

      .bdw-tab.is-incomplete:not(.is-active){
        border-color:rgba(180,35,24,.28);
      }

      .bdw-tab-no{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        width:20px;
        height:20px;
        border-radius:50%;
        background:rgba(0,0,0,.07);
        font-size:9px;
        font-weight:700;
      }

      .bdw-tab.is-active .bdw-tab-no{
        background:rgba(255,255,255,.16);
      }

      .bdw-tab.is-complete:not(.is-active) .bdw-tab-no{
        background:#111;
        color:#fff;
      }

      .bdw-body{
        min-height:310px;
        padding:20px;
      }

      .bdw-intro{
        display:flex;
        flex-direction:column;
        gap:4px;
        margin-bottom:16px;
      }

      .bdw-intro strong{
        font-size:14px;
      }

      .bdw-intro span{
        max-width:760px;
        font-size:10.5px;
        line-height:1.5;
        opacity:.62;
      }

      .bdw-products{
        display:flex;
        flex-direction:column;
        gap:8px;
      }

      .bdw-product-card{
        display:grid;
        grid-template-columns:58px minmax(0,1fr) minmax(190px,245px);
        gap:12px;
        align-items:center;
        min-width:0;
        padding:9px;
        border:1px solid rgba(0,0,0,.09);
        border-radius:9px;
        background:rgba(0,0,0,.012);
      }

      .bdw-product-image{
        width:58px;
        height:72px;
        object-fit:cover;
        border-radius:7px;
        background:rgba(0,0,0,.06);
      }

      .bdw-product-copy{
        min-width:0;
      }

      .bdw-product-copy strong{
        display:block;
        font-size:11px;
        line-height:1.35;
        overflow-wrap:anywhere;
      }

      .bdw-product-copy span{
        display:block;
        margin-top:4px;
        font-size:9.5px;
        opacity:.60;
      }

      .bdw-product-meta{
        display:flex;
        flex-wrap:wrap;
        align-items:center;
        gap:5px 9px;
        margin-top:4px;
      }

      .bdw-product-meta span{
        margin-top:0;
      }

      .bdw-product-price{
        opacity:1 !important;
        font-weight:650;
      }

      .bdw-product-qty{
        padding-left:8px;
        border-left:1px solid rgba(0,0,0,.12);
      }

      .bdw-product-select{
        display:flex;
        flex-direction:column;
        gap:5px;
        min-width:0;
      }

      .bdw-product-select > span{
        font-size:9px;
        opacity:.58;
      }

      .bdw-product-select select{
        width:100%;
        min-height:40px;
        padding:8px 10px;
        border:1px solid rgba(0,0,0,.14);
        border-radius:8px;
        background:#fff;
        color:#111;
        font:inherit;
        font-size:10.5px;
      }

      .bdw-group-head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin-bottom:12px;
      }

      .bdw-group-state{
        display:flex;
        align-items:center;
        gap:9px;
      }

      .bdw-group-state > span{
        display:flex;
        align-items:center;
        justify-content:center;
        width:27px;
        height:27px;
        border-radius:50%;
        background:#111;
        color:#fff;
        font-size:10px;
        font-weight:700;
      }

      .bdw-group-state.is-incomplete > span{
        background:#b42318;
      }

      .bdw-group-state strong,
      .bdw-group-state small{
        display:block;
      }

      .bdw-group-state strong{
        font-size:11px;
      }

      .bdw-group-state small{
        margin-top:2px;
        font-size:9.5px;
        opacity:.58;
      }

      .bdw-link-button{
        border:0;
        background:none;
        color:inherit;
        padding:4px;
        font:inherit;
        font-size:9.5px;
        text-decoration:underline;
        cursor:pointer;
      }

      .bdw-fee-row{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:14px;
        margin:15px 0 2px;
        padding:12px 0;
        border-top:1px solid rgba(0,0,0,.08);
        border-bottom:1px solid rgba(0,0,0,.08);
        font-size:10.5px;
      }

      .bdw-fee-row strong{
        font-size:11.5px;
      }

      .bdw-form-grid{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:12px;
        margin-top:12px;
      }

      .bdw-field{
        display:flex;
        flex-direction:column;
        gap:5px;
        min-width:0;
      }

      .bdw-field > span{
        font-size:10px;
        opacity:.70;
      }

      .bdw-field select,
      .bdw-field input{
        width:100%;
        min-height:42px;
        box-sizing:border-box;
        padding:8px 10px;
        border:1px solid rgba(0,0,0,.14);
        border-radius:8px;
        background:#fff;
        color:#111;
        font:inherit;
        font-size:10.5px;
      }

      .bdw-field small{
        font-size:9px;
        line-height:1.4;
        opacity:.58;
      }

      .bdw-field small.is-success{
        opacity:1;
        font-weight:600;
      }

      .bdw-field--barcode{
        grid-column:1 / -1;
      }

      .bdw-review-list{
        display:flex;
        flex-direction:column;
        gap:8px;
      }

      .bdw-review-card{
        display:grid;
        grid-template-columns:32px minmax(0,1fr) auto;
        gap:11px;
        align-items:center;
        padding:12px;
        border:1px solid rgba(0,0,0,.09);
        border-radius:9px;
      }

      .bdw-review-card.is-incomplete{
        border-color:rgba(180,35,24,.35);
        background:#fff8f7;
      }

      .bdw-review-icon{
        display:flex;
        align-items:center;
        justify-content:center;
        width:29px;
        height:29px;
        border-radius:50%;
        background:#111;
        color:#fff;
        font-size:10px;
        font-weight:700;
      }

      .bdw-review-card.is-incomplete .bdw-review-icon{
        background:#b42318;
      }

      .bdw-review-copy strong,
      .bdw-review-copy span,
      .bdw-review-copy small{
        display:block;
      }

      .bdw-review-copy strong{
        font-size:11px;
      }

      .bdw-review-copy span{
        margin-top:2px;
        font-size:9.5px;
        opacity:.58;
      }

      .bdw-review-copy small{
        margin-top:4px;
        font-size:9px;
        line-height:1.4;
        opacity:.70;
      }

      .bdw-review-edit{
        min-height:34px;
        padding:7px 10px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:7px;
        background:#fff;
        color:#111;
        font:inherit;
        font-size:9.5px;
        cursor:pointer;
      }

      .bdw-review-warning,
      .bdw-error{
        display:flex;
        flex-direction:column;
        gap:4px;
        margin-top:12px;
        padding:11px 12px;
        border:1px solid #c62828;
        border-radius:8px;
        background:#fff4f4;
        color:#9e1d1d;
        font-size:10px;
        line-height:1.45;
      }

      .bdw-error{
        margin:0 0 14px;
      }

      .bdw-review-warning strong,
      .bdw-error strong{
        font-size:10.5px;
      }

      .bdw-footer{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        padding:13px 20px;
        border-top:1px solid rgba(0,0,0,.08);
        background:#fff;
        position:sticky;
        bottom:0;
        z-index:7;
      }

      .bdw-button{
        min-height:43px;
        padding:9px 14px;
        border-radius:8px;
        font:inherit;
        font-size:10px;
        cursor:pointer;
      }

      .bdw-button--ghost{
        border:1px solid rgba(0,0,0,.22);
        background:#fff;
        color:#111;
      }

      .bdw-button--primary{
        border:1px solid #111;
        background:#111;
        color:#fff;
      }

      .bdw-button:disabled{
        opacity:.34;
        cursor:not-allowed;
      }

      .bdw-empty{
        padding:22px;
        border:1px dashed rgba(0,0,0,.15);
        border-radius:9px;
        text-align:center;
        font-size:10.5px;
        opacity:.58;
      }

      @media (max-width: 749px){
        html.bigdora-wizard-v4-active #bigdora-shipment-groups.bdw-root{
          margin-left:-12px;
          margin-right:-12px;
          width:calc(100% + 24px);
        }

        .bdw-shell{
          border-left:0;
          border-right:0;
          border-radius:0;
        }

        .bdw-header{
          align-items:flex-start;
          flex-direction:column;
          gap:12px;
          padding:16px 13px 13px;
        }

        .bdw-header h2{
          font-size:19px;
        }

        .bdw-progress-wrap{
          width:100%;
          max-width:none;
        }

        .bdw-progress-wrap > span{
          text-align:left;
        }

        .bdw-tabs{
          padding:9px 10px;
        }

        .bdw-tab{
          min-height:32px;
          padding:5px 8px;
          font-size:9.5px;
        }

        .bdw-body{
          min-height:260px;
          padding:14px 11px 18px;
        }

        .bdw-intro{
          margin-bottom:13px;
        }

        .bdw-intro strong{
          font-size:13px;
        }

        .bdw-product-card{
          grid-template-columns:52px minmax(0,1fr);
          gap:9px;
        }

        .bdw-product-image{
          width:52px;
          height:66px;
        }

        .bdw-product-select{
          grid-column:1 / -1;
        }

        .bdw-product-select select{
          min-height:44px;
          font-size:11px;
        }

        .bdw-form-grid{
          grid-template-columns:1fr;
          gap:10px;
        }

        .bdw-field--barcode{
          grid-column:auto;
        }

        .bdw-field select,
        .bdw-field input{
          min-height:45px;
          font-size:11px;
        }

        .bdw-group-head{
          align-items:flex-start;
        }

        .bdw-review-card{
          grid-template-columns:30px minmax(0,1fr);
        }

        .bdw-review-edit{
          grid-column:1 / -1;
          width:100%;
        }

        .bdw-footer{
          padding:9px 10px calc(9px + env(safe-area-inset-bottom));
        }

        .bdw-button{
          min-height:48px;
          padding:9px 11px;
          font-size:10.5px;
        }

        .bdw-button--ghost{
          flex:0 0 34%;
        }

        .bdw-button--primary{
          flex:1 1 auto;
        }
      }
    `;

    document.head.appendChild(style);
  }


  function renderGroups() {
    if (IS_CART_PAGE) {
      renderWizard();
      return;
    }

    const panel = createPanel();
    if (!panel) return;

    const groups = sortedGroups();

    if (!groups.length) {
      panel.innerHTML = '';
      panel.style.display = 'none';
      return;
    }

    panel.style.display = '';

    let html =
      '<div class="bigdora-planner-head">' +
        '<div>' +
          '<div class="bigdora-shipment-groups__title">Gönderi Planı</div>' +
          '<div class="bigdora-planner-head__sub">Her fulfillment müşterisinin ürünlerini ve kargo bilgilerini ayrı yönetin. Kargo firması zorunludur; takip kodu veya barkoddan en az biri yeterlidir. İkisini birlikte de ekleyebilirsiniz.</div>' +
        '</div>' +
        '<div class="bigdora-planner-count">' + groups.length + ' gönderi</div>' +
      '</div>';

    groups.forEach(function (groupId) {
      const group = state.groups[groupId];
      const products = productsInGroup(groupId);
      const fulfillmentFee = fulfillmentFeeForGroup(groupId);
      const missing = groupMissingFields(groupId);

      html +=
        '<section class="bigdora-shipment-card' +
        (missing.length ? ' is-incomplete' : ' is-complete') +
        '" data-group-id="' +
        escapeHtml(groupId) +
        '">';

      html +=
        '<div class="bigdora-shipment-card__head">' +
          '<div class="bigdora-shipment-card__head-main">' +
            '<span class="bigdora-shipment-status">' +
              (missing.length ? '!' : '✓') +
            '</span>' +
            '<div>' +
              '<strong>' + escapeHtml(group.name) + '</strong>' +
              '<small>' +
                (missing.length
                  ? 'Eksik: ' + escapeHtml(missing.join(', '))
                  : 'Gönderi bilgileri tamamlandı') +
              '</small>' +
            '</div>' +
          '</div>' +
          '<button type="button" data-delete-shipment="' +
            escapeHtml(groupId) +
          '">Gönderiyi sil</button>' +
        '</div>';

      html += '<div class="bigdora-shipment-products">';

      products.forEach(function (product) {
        html +=
          '<div class="bigdora-shipment-product">' +
            (product.image
              ? '<img src="' + escapeHtml(product.image) + '" alt="">'
              : '<div class="bigdora-shipment-product__placeholder"></div>') +
            '<div class="bigdora-shipment-product__info">' +
              '<strong>' + escapeHtml(product.title) + '</strong>' +
              (product.variant
                ? '<span>' + escapeHtml(product.variant) + '</span>'
                : '') +
            '</div>' +
          '</div>';
      });

      html += '</div>';

      html +=
        '<div class="bigdora-shipment-card__fee">' +
          '<span>Fulfillment hizmet bedeli</span>' +
          '<strong>' +
            fulfillmentFee.toLocaleString('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) +
          ' TL</strong>' +
        '</div>';

      html +=
        '<div class="bigdora-shipment-form-grid">' +

          '<label class="bigdora-shipment-field">' +
            '<span>Kargo firması <b>*</b></span>' +
            '<select data-shipment-carrier="' + escapeHtml(groupId) + '">' +
              '<option value="">Kargo firması seçin</option>' +
              '<option value="Aras Kargo">Aras Kargo</option>' +
              '<option value="Yurtiçi Kargo">Yurtiçi Kargo</option>' +
              '<option value="MNG Kargo">MNG Kargo</option>' +
              '<option value="Sürat Kargo">Sürat Kargo</option>' +
              '<option value="PTT Kargo">PTT Kargo</option>' +
              '<option value="Sendeo">Sendeo</option>' +
              '<option value="Kolay Gelsin">Kolay Gelsin</option>' +
              '<option value="HepsiJET">HepsiJET</option>' +
              '<option value="Trendyol Express">Trendyol Express</option>' +
              '<option value="Scotty">Scotty</option>' +
              '<option value="UPS">UPS</option>' +
              '<option value="DHL">DHL</option>' +
              '<option value="FedEx">FedEx</option>' +
              '<option value="Diğer">Diğer</option>' +
            '</select>' +
          '</label>' +

          '<label class="bigdora-shipment-field">' +
            '<span>Kargo kodu / takip numarası</span>' +
            '<input type="text" data-shipment-code="' +
              escapeHtml(groupId) +
              '" placeholder="Kargo kodunu girin">' +
            '<small>Takip kodu veya barkoddan en az biri zorunlu · İkisini birlikte de ekleyebilirsiniz</small>' +
          '</label>' +

          '<label class="bigdora-shipment-field bigdora-shipment-field--barcode">' +
            '<span>Kargo barkodu / etiketi</span>' +
            '<input type="file" ' +
              'data-shipment-barcode="' +
              escapeHtml(groupId) +
              '" accept=".pdf,.jpg,.jpeg,.png,.webp">' +
            '<small class="' +
              (group.barcodeUrl ? 'is-success' : '') +
            '">' +
              (group.barcodeUploading
                ? 'Yükleniyor...'
                : (group.barcodeUrl
                    ? '✓ Yüklendi: ' + escapeHtml(group.barcodeName || 'Kargo barkodu')
                    : 'Takip kodu veya barkoddan en az biri zorunlu · İkisini birlikte de ekleyebilirsiniz · PDF/görsel · en fazla 20 MB')) +
            '</small>' +
          '</label>' +

        '</div>';

      html += '</section>';
    });

    panel.innerHTML = html;

    groups.forEach(function (groupId) {
      const group = state.groups[groupId];

      const carrier = panel.querySelector(
        '[data-shipment-carrier="' + CSS.escape(groupId) + '"]'
      );

      const code = panel.querySelector(
        '[data-shipment-code="' + CSS.escape(groupId) + '"]'
      );

      if (carrier) carrier.value = group.carrier || '';
      if (code) code.value = group.code || '';
    });
  }

  function refreshSelectors() {
    document
      .querySelectorAll('[data-bigdora-shipment-select]')
      .forEach(function (select) {
        updateSelectOptions(select);
      });
  }


  function getLiveCartDrawer() {
    return (
      document.querySelector('theme-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('.cart-drawer')
    );
  }

  function renderDrawerSummary() {
    if (IS_CART_PAGE) return;

    const drawer = getLiveCartDrawer();
    if (!drawer) return;

    let summary = drawer.querySelector('#bigdora-drawer-order-summary');

    /*
      Drawer temaya göre farklı HTML ile gelebiliyor.
      Öncelik: ürün listesinin hemen altı.
      Bulamazsak ödeme/özet alanının hemen üstüne koyuyoruz.
    */
    const itemsWrapper =
      drawer.querySelector('.cart-items__wrapper') ||
      drawer.querySelector('.cart-items') ||
      drawer.querySelector('[data-cart-items]') ||
      drawer.querySelector('form[action*="/cart"]');

    const summaryArea =
      drawer.querySelector('.cart__summary') ||
      drawer.querySelector('.cart__footer') ||
      drawer.querySelector('.cart__ctas') ||
      drawer.querySelector('[name="checkout"]')?.parentElement ||
      drawer.querySelector('.cart__checkout-button')?.parentElement;

    if (!summary) {
      summary = document.createElement('section');
      summary.id = 'bigdora-drawer-order-summary';
      summary.className = 'bigdora-drawer-order-summary';

      if (itemsWrapper && itemsWrapper.parentNode) {
        itemsWrapper.insertAdjacentElement('afterend', summary);
      } else if (summaryArea && summaryArea.parentNode) {
        summaryArea.insertAdjacentElement('beforebegin', summary);
      } else {
        drawer.appendChild(summary);
      }
    }

    const groupCount = sortedGroups().length;

    /*
      Local state eski line key taşıyorsa ürün sayısı sapmasın.
      Drawer'daki görünür normal ürün satırlarını esas al.
    */
    const visibleRows = Array.from(
      drawer.querySelectorAll('.cart-items__table-row')
    ).filter(function (row) {
      return !row.querySelector('[data-bigdora-ff-service-line]');
    });

    const productCount =
      visibleRows.length ||
      Object.keys(state.assignments || {}).length;

    summary.innerHTML =
      '<div class="bigdora-drawer-order-summary__top">' +
        '<div class="bigdora-drawer-order-summary__icon">i</div>' +
        '<div>' +
          '<strong>Sepetiniz hazır. Gönderi planını sonraki adımda oluşturun.</strong>' +
          '<p>Bu ekran yalnızca sepet özetidir. Ürünleri kime göndereceğinizi ve kargo bilgilerini Sipariş Hazırlama ekranında belirleyeceksiniz.</p>' +
        '</div>' +
      '</div>' +
      '<div class="bigdora-drawer-order-summary__steps">' +
        '<span><b>1</b> Ürünleri ayır</span>' +
        '<span><b>2</b> Kargo bilgilerini gir</span>' +
        '<span><b>3</b> Kontrol et ve öde</span>' +
      '</div>' +
      '<div class="bigdora-drawer-order-summary__bottom">' +
        '<div class="bigdora-drawer-order-summary__meta">' +
          '<span>' + productCount + ' ürün</span>' +
          (groupCount
            ? '<span>' + groupCount + ' fulfillment gönderisi</span>'
            : '<span>Gönderiler henüz ayrılmadı</span>') +
        '</div>' +
        '<a href="/pages/siparis-hazirla" class="bigdora-drawer-order-summary__button">Sipariş Düzenini Hazırla</a>' +
      '</div>';
  }

  function renderAll() {
    captureLineMetaFromDOM();
    refreshSelectors();
    renderGroups();
    renderDrawerSummary();
  }

  document.addEventListener('change', function (event) {
    const select = event.target.closest(
      '[data-bigdora-shipment-select]'
    );

    if (select) {
      const wrapper = select.closest('.bigdora-shipment-selector');
      if (!wrapper) return;

      const lineKey = wrapper.dataset.lineKey;
      let value = select.value;

      if (value === 'new') {
        value = createGroup();
      }

      state.assignments[lineKey] = value;

      cleanupGroups();
      saveState();
      renderAll();

      persistLineAssignment(lineKey, value).then(function () {
        renderAll();
        scheduleFulfillmentSync(40);
      });

      return;
    }

    if (event.target.matches('[data-shipment-carrier]')) {
      const groupId = event.target.dataset.shipmentCarrier;

      if (state.groups[groupId]) {
        state.groups[groupId].carrier = event.target.value;
        saveState();
        persistGroupMetadata(groupId).then(function () {
          if (IS_CART_PAGE) renderWizard();
        });
      }
    }

    if (event.target.matches('[data-shipment-barcode]')) {
      const groupId = event.target.dataset.shipmentBarcode;

      const file =
        event.target.files && event.target.files[0]
          ? event.target.files[0]
          : null;

      if (!file) return;

      if (file.size > 20 * 1024 * 1024) {
        alert('Kargo barkodu 20 MB sınırını aşıyor.');
        event.target.value = '';
        return;
      }

      uploadBarcodeForGroup(groupId, file);
    }
  });

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-shipment-code]')) {
      const groupId = event.target.dataset.shipmentCode;

      if (state.groups[groupId]) {
        state.groups[groupId].code = event.target.value;
        saveState();

        clearTimeout(event.target._bigdoraPersistTimer);
        event.target._bigdoraPersistTimer = setTimeout(function () {
          persistGroupMetadata(groupId).then(function () {
            if (IS_CART_PAGE) {
              const active = document.activeElement;
              if (!active || !active.matches('[data-shipment-code]')) {
                renderWizard();
              }
            }
          });
        }, 450);
      }
    }
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-delete-shipment]');
    if (!button) return;

    const groupId = button.dataset.deleteShipment;
    const affectedKeys = [];

    Object.keys(state.assignments).forEach(function (lineKey) {
      if (state.assignments[lineKey] === groupId) {
        affectedKeys.push(lineKey);
        state.assignments[lineKey] = 'dealer';
      }
    });

    let chain = Promise.resolve();

    affectedKeys.forEach(function (lineKey) {
      chain = chain.then(function () {
        return persistLineAssignment(lineKey, 'dealer');
      });
    });

    chain.then(function () {
      delete state.groups[groupId];
      saveState();
      renderAll();
      scheduleFulfillmentSync();
    });
  });


  function validateFulfillmentBeforeCheckout() {
    const groups = sortedGroups();
    const errors = [];

    groups.forEach(function (groupId) {
      const group = state.groups[groupId];
      const missing = groupMissingFields(groupId);

      if (missing.length) {
        errors.push({
          groupId: groupId,
          name: group ? group.name : groupId,
          missing: missing
        });
      }
    });

    if (!errors.length) {
      showCheckoutValidation('');
      return true;
    }

    const message =
      'Ödeme adımına geçmek için gönderi bilgilerini tamamlayın. ' +
      errors
        .map(function (error) {
          return error.name + ': ' + error.missing.join(', ');
        })
        .join(' · ');

    showCheckoutValidation(message);

    renderGroups();

    const first = errors[0];

    setTimeout(function () {
      const card = document.querySelector(
        '.bigdora-shipment-card[data-group-id="' +
          CSS.escape(first.groupId) +
        '"]'
      );

      if (card) {
        card.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        card.classList.add('bigdora-shipment-card--attention');

        setTimeout(function () {
          card.classList.remove('bigdora-shipment-card--attention');
        }, 1800);
      }
    }, 50);

    return false;
  }

  function showCheckoutValidation(message) {
    document
      .querySelectorAll('.bigdora-checkout-validation')
      .forEach(function (el) {
        el.remove();
      });

    if (!message) return;

    const html =
      '<strong>⚠ Gönderi bilgileri eksik</strong>' +
      '<span>' + escapeHtml(message) + '</span>';

    const checkoutButtons = Array.from(
      document.querySelectorAll(
        '.cart__checkout-button, [name="checkout"], a[href*="/checkout"]'
      )
    );

    const usedParents = new Set();

    checkoutButtons.forEach(function (button) {
      const parent =
        button.closest('.cart__ctas') ||
        button.parentElement;

      if (!parent || usedParents.has(parent)) return;
      usedParents.add(parent);

      const box = document.createElement('div');
      box.className =
        'bigdora-checkout-validation bigdora-checkout-validation--summary';
      box.innerHTML = html;
      parent.insertBefore(box, button);
    });

    const panel = document.querySelector('#bigdora-shipment-groups');

    if (panel) {
      const box = document.createElement('div');
      box.className = 'bigdora-checkout-validation';
      box.innerHTML = html;
      panel.prepend(box);
    }

    if (!checkoutButtons.length && !panel) {
      alert(message);
    }
  }

  function isCheckoutControl(el) {
    if (!el) return false;

    if (el.matches('a[href*="/checkout"]')) return true;
    if (el.matches('[name="checkout"]')) return true;
    if (el.matches('.cart__checkout-button')) return true;

    const text = (el.textContent || '').trim().toLowerCase();

    return (
      text === 'ödeme' ||
      text === 'ödemeye geç' ||
      text.includes('checkout')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const control = event.target.closest('a, button, input[type="submit"]');
      if (!isCheckoutControl(control)) return;

      if (!validateFulfillmentBeforeCheckout()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const submitter = event.submitter;

      if (
        (submitter && isCheckoutControl(submitter)) ||
        (event.target && event.target.matches('form[action*="/cart"]'))
      ) {
        if (!validateFulfillmentBeforeCheckout()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
    },
    true
  );

  function injectStyles() {
    if (document.getElementById('bigdora-shipment-styles')) return;

    const style = document.createElement('style');
    style.id = 'bigdora-shipment-styles';

    style.textContent = `
      .bigdora-shipment-groups{
        display:flex;
        flex-direction:column;
        gap:12px;
        margin-top:18px;
        padding-top:18px;
        border-top:1px solid rgba(0,0,0,.12);
      }

      .bigdora-shipment-groups__title{
        font-size:14px;
        font-weight:700;
      }

      .bigdora-shipment-card{
        padding:14px;
        border:1px solid rgba(0,0,0,.14);
        border-radius:10px;
        background:rgba(0,0,0,.02);
      }

      .bigdora-shipment-card__head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:10px;
        margin-bottom:10px;
      }

      .bigdora-shipment-card__head button{
        border:0;
        background:none;
        padding:0;
        font-size:11px;
        text-decoration:underline;
        cursor:pointer;
      }

      .bigdora-shipment-card__fee{
        display:flex;
        justify-content:space-between;
        align-items:center;
        gap:12px;
        margin:10px 0 4px;
        padding:10px 0;
        border-top:1px solid rgba(0,0,0,.08);
        border-bottom:1px solid rgba(0,0,0,.08);
        font-size:12px;
      }

      .bigdora-shipment-field{
        display:flex;
        flex-direction:column;
        gap:5px;
        margin-top:10px;
      }

      .bigdora-shipment-field span{
        font-size:11px;
        opacity:.7;
      }

      .bigdora-shipment-field small{
        font-size:10px;
        opacity:.6;
      }

      .bigdora-shipment-field select,
      .bigdora-shipment-field input{
        width:100%;
        min-height:40px;
        padding:8px 10px;
        border:1px solid rgba(0,0,0,.15);
        border-radius:8px;
        background:#fff;
        font:inherit;
        font-size:12px;
      }

      .bigdora-shipment-fee-error{
        padding:10px 12px;
        border:1px solid #111;
        border-radius:8px;
        font-size:11px;
        line-height:1.5;
      }

      .bigdora-planner-head{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:12px;
        margin-bottom:12px;
      }

      .bigdora-planner-head__sub{
        margin-top:3px;
        font-size:11px;
        line-height:1.45;
        opacity:.62;
      }

      .bigdora-planner-count{
        flex:0 0 auto;
        padding:5px 8px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:999px;
        font-size:10px;
        white-space:nowrap;
      }

      .bigdora-shipment-card__head-main{
        display:flex;
        align-items:flex-start;
        gap:9px;
      }

      .bigdora-shipment-card__head-main small{
        display:block;
        margin-top:2px;
        font-size:10px;
        opacity:.62;
        font-weight:400;
      }

      .bigdora-shipment-status{
        display:inline-flex;
        width:22px;
        height:22px;
        align-items:center;
        justify-content:center;
        border-radius:50%;
        background:#111;
        color:#fff;
        font-size:11px;
        flex:0 0 auto;
      }

      .bigdora-shipment-products{
        display:flex;
        flex-direction:column;
        gap:8px;
        margin:12px 0;
      }

      .bigdora-shipment-product{
        display:grid;
        grid-template-columns:46px minmax(0,1fr);
        gap:9px;
        align-items:center;
        padding:7px;
        border:1px solid rgba(0,0,0,.08);
        border-radius:8px;
        background:rgba(0,0,0,.018);
      }

      .bigdora-shipment-product img,
      .bigdora-shipment-product__placeholder{
        width:46px;
        height:58px;
        object-fit:cover;
        border-radius:6px;
        background:rgba(0,0,0,.06);
      }

      .bigdora-shipment-product__info{
        min-width:0;
      }

      .bigdora-shipment-product__info strong{
        display:block;
        font-size:11px;
        line-height:1.35;
        overflow-wrap:anywhere;
      }

      .bigdora-shipment-product__info span{
        display:block;
        margin-top:3px;
        font-size:10px;
        opacity:.65;
      }

      .bigdora-shipment-form-grid{
        display:grid;
        grid-template-columns:1fr;
        gap:10px;
      }

      .bigdora-shipment-field small.is-success{
        opacity:1;
        font-weight:600;
      }

      .bigdora-checkout-validation{
        display:flex;
        flex-direction:column;
        gap:5px;
        margin-bottom:12px;
        padding:12px 13px;
        border:1px solid #c62828;
        border-radius:9px;
        background:#fff4f4;
        color:#a61b1b;
        font-size:11px;
        line-height:1.5;
      }

      .bigdora-checkout-validation strong{
        font-size:12px;
        color:#8e1515;
      }

      .bigdora-checkout-validation--summary{
        width:100%;
        box-sizing:border-box;
        margin-bottom:10px;
      }

      .bigdora-shipment-card--attention{
        animation:bigdoraAttention .5s ease 0s 3 alternate;
      }

      @keyframes bigdoraAttention{
        from{box-shadow:0 0 0 0 rgba(0,0,0,0)}
        to{box-shadow:0 0 0 3px rgba(0,0,0,.18)}
      }

      theme-drawer#cart-drawer .bigdora-shipment-groups{
        width:100%;
        max-width:100%;
        min-width:0;
        overflow:hidden;
        box-sizing:border-box;
      }

      theme-drawer#cart-drawer .bigdora-shipment-card,
      theme-drawer#cart-drawer .bigdora-shipment-product,
      theme-drawer#cart-drawer .bigdora-shipment-form-grid,
      theme-drawer#cart-drawer .bigdora-shipment-field{
        min-width:0;
        max-width:100%;
        box-sizing:border-box;
      }

      theme-drawer#cart-drawer .bigdora-shipment-form-grid{
        grid-template-columns:1fr !important;
      }

      theme-drawer#cart-drawer .bigdora-shipment-field--barcode{
        grid-column:auto !important;
      }

      theme-drawer#cart-drawer .bigdora-shipment-field select,
      theme-drawer#cart-drawer .bigdora-shipment-field input{
        max-width:100%;
        box-sizing:border-box;
      }

      @media (min-width: 900px){
        .bigdora-shipment-form-grid{
          grid-template-columns:1fr 1fr;
        }

        .bigdora-shipment-field--barcode{
          grid-column:1 / -1;
        }
      }

      /* v4.1: Drawer yalnızca özet ekranıdır. */
      theme-drawer#cart-drawer .bigdora-shipment-selector{
        display:none !important;
      }

      theme-drawer#cart-drawer #bigdora-shipment-groups,
      #cart-drawer #bigdora-shipment-groups,
      [data-cart-drawer] #bigdora-shipment-groups,
      .cart-drawer #bigdora-shipment-groups{
        display:none !important;
      }

      theme-drawer#cart-drawer .bigdora-shipment-selector,
      #cart-drawer .bigdora-shipment-selector,
      [data-cart-drawer] .bigdora-shipment-selector,
      .cart-drawer .bigdora-shipment-selector{
        display:none !important;
      }

      /*
        Drawer artık özet + Sipariş Düzenini Hazırla ekranı.
        Native ödeme butonu yalnızca /cart wizard son adımından kullanılacak.
      */
      theme-drawer#cart-drawer .cart__checkout-button,
      theme-drawer#cart-drawer [name="checkout"],
      #cart-drawer .cart__checkout-button,
      #cart-drawer [name="checkout"],
      [data-cart-drawer] .cart__checkout-button,
      [data-cart-drawer] [name="checkout"],
      .cart-drawer .cart__checkout-button,
      .cart-drawer [name="checkout"]{
        display:none !important;
      }

      .bigdora-drawer-order-summary{
        display:flex;
        flex-direction:column;
        gap:12px;
        margin:14px 0 6px;
        padding:14px;
        border:1px solid rgba(0,0,0,.12);
        border-radius:12px;
        background:#fafafa;
        box-sizing:border-box;
      }

      .bigdora-drawer-order-summary__top{
        display:grid;
        grid-template-columns:30px minmax(0,1fr);
        gap:11px;
        align-items:flex-start;
      }

      .bigdora-drawer-order-summary__icon{
        display:flex;
        align-items:center;
        justify-content:center;
        width:28px;
        height:28px;
        border-radius:50%;
        background:#111;
        color:#fff;
        font-size:11px;
        font-weight:700;
      }

      .bigdora-drawer-order-summary__content{
        min-width:0;
      }

      .bigdora-drawer-order-summary__content strong{
        display:block;
        font-size:11.5px;
        line-height:1.35;
      }

      .bigdora-drawer-order-summary__content p,
      .bigdora-drawer-order-summary__top p{
        margin:5px 0 0;
        font-size:10px;
        line-height:1.5;
        opacity:.64;
      }

      .bigdora-drawer-order-summary__top strong{
        display:block;
        font-size:11.5px;
        line-height:1.4;
      }

      .bigdora-drawer-order-summary__steps{
        display:grid;
        grid-template-columns:1fr;
        gap:6px;
        padding:9px 10px;
        border-radius:9px;
        background:#fff;
        border:1px solid rgba(0,0,0,.08);
      }

      .bigdora-drawer-order-summary__steps span{
        display:flex;
        align-items:center;
        gap:8px;
        font-size:9.5px;
        line-height:1.35;
      }

      .bigdora-drawer-order-summary__steps b{
        display:flex;
        align-items:center;
        justify-content:center;
        width:20px;
        height:20px;
        flex:0 0 20px;
        border-radius:50%;
        background:#111;
        color:#fff;
        font-size:8.5px;
      }

      .bigdora-drawer-order-summary__bottom{
        display:flex;
        flex-direction:column;
        gap:9px;
      }

      .bigdora-drawer-order-summary__meta{
        display:flex;
        flex-wrap:wrap;
        gap:6px;
        margin-bottom:10px;
      }

      .bigdora-drawer-order-summary__meta span{
        display:inline-flex;
        align-items:center;
        min-height:24px;
        padding:4px 7px;
        border:1px solid rgba(0,0,0,.10);
        border-radius:999px;
        background:#fff;
        font-size:9px;
        line-height:1;
      }

      .bigdora-drawer-order-summary__button{
        display:flex;
        align-items:center;
        justify-content:center;
        width:100%;
        min-height:42px;
        padding:9px 12px;
        box-sizing:border-box;
        border-radius:8px;
        background:#111;
        color:#fff !important;
        text-decoration:none !important;
        font-size:10.5px;
        font-weight:600;
        text-align:center;
      }

      @media (max-width: 749px){
        .bigdora-drawer-order-summary{
          margin-top:12px;
          padding:13px;
          gap:11px;
        }

        .bigdora-drawer-order-summary__top strong{
          font-size:12px;
        }

        .bigdora-drawer-order-summary__top p{
          font-size:10.5px;
        }

        .bigdora-drawer-order-summary__steps span{
          font-size:10px;
        }

        .bigdora-drawer-order-summary__button{
          min-height:46px;
          font-size:11px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function hydrateShipmentStateFromCart() {
    captureLineMetaFromDOM();

    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        const config = getFFConfig();
        const liveKeys = {};

        cart.items.forEach(function (item) {
          const props = item.properties || {};

          if (config && item.product_id === config.productId) {
            const groupId = props['_Bigdora FF Group'];
            if (!groupId) return;

            const group = ensureGroup(
              groupId,
              props['Fulfillment Müşterisi'] || ''
            );

            if (!group) return;

            const token = props['_Bigdora FF Token'];
            const barcodeUrl = props['Kargo Barkodu'];

            if (token) group.token = token;
            if (props['Kargo Firması']) group.carrier = props['Kargo Firması'];
            if (props['Kargo Takip Kodu']) group.code = props['Kargo Takip Kodu'];

            if (barcodeUrl) {
              group.barcodeUrl = barcodeUrl;

              if (!group.barcodeName) {
                group.barcodeName =
                  String(barcodeUrl).split('/').pop().split('?')[0] ||
                  'Kargo barkodu';
              }
            }

            return;
          }

          liveKeys[item.key] = true;

          const existing = state.lineMeta[item.key] || {};
          const privateFee =
            parseFloat(props['_Bigdora FF Bedel'] || '0') || 0;

          state.lineMeta[item.key] = Object.assign({}, existing, {
            title: item.product_title || existing.title || '',
            variant: item.variant_title || existing.variant || '',
            image: item.image || existing.image || '',
            url: item.url || existing.url || '',
            variantId: item.variant_id || existing.variantId || 0,
            fee: privateFee || existing.fee || 0,
            unitPrice:
              typeof item.final_price === 'number'
                ? item.final_price
                : (typeof item.price === 'number'
                    ? item.price
                    : (existing.unitPrice || 0)),
            linePrice:
              typeof item.final_line_price === 'number'
                ? item.final_line_price
                : (typeof item.line_price === 'number'
                    ? item.line_price
                    : (existing.linePrice || 0)),
            quantity:
              parseInt(item.quantity || existing.quantity || 1, 10) || 1
          });

          const shipmentName =
            props['Fulfillment Müşterisi'] ||
            props['Gönderi'] ||
            '';

          const groupId = groupIdFromName(shipmentName);

          if (groupId) {
            const group = ensureGroup(groupId, shipmentName);

            state.assignments[item.key] = groupId;

            if (props['Kargo Firması']) {
              group.carrier = props['Kargo Firması'];
            }

            if (props['Kargo Takip Kodu']) {
              group.code = props['Kargo Takip Kodu'];
            }
          } else {
            state.assignments[item.key] = 'dealer';
          }
        });

        Object.keys(state.assignments).forEach(function (key) {
          if (!liveKeys[key]) {
            delete state.assignments[key];
          }
        });

        Object.keys(state.lineMeta).forEach(function (key) {
          if (!liveKeys[key]) {
            delete state.lineMeta[key];
          }
        });

        cleanupGroups();
        saveState();
      })
      .catch(function () {});
  }

  injectStyles();
  injectWizardStyles();

  hydrateShipmentStateFromCart().then(function () {
    renderAll();
    scheduleFulfillmentSync(120);
  });

  setInterval(function () {
    refreshSelectors();
    renderDrawerSummary();

    const hasSelectors =
      document.querySelector('[data-bigdora-shipment-select]');

    if (
      hasSelectors &&
      !document.querySelector('#bigdora-shipment-groups')
    ) {
      renderGroups();
    }
  }, 700);

  function clearShipmentState() {
    localStorage.removeItem(STORAGE_KEY);
    state = defaultState();
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('button, a');
    if (!button) return;

    const text = (button.textContent || '').trim().toLowerCase();

    if (
      text.includes('sepeti temizle') ||
      text.includes('clear cart')
    ) {
      clearShipmentState();
    }
  });

  function temizSepetiKontrolEt() {
    fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;

        const config = getFFConfig();

        const normalProducts = cart.items.filter(function (item) {
          if (config && config.productId) {
            return item.product_id !== config.productId;
          }

          return item.product_title !== 'Fulfillment Hizmeti';
        });

        if (normalProducts.length === 0) {
          clearShipmentState();
        }
      })
      .catch(function () {});
  }

  setInterval(temizSepetiKontrolEt, 1500);

  setTimeout(function () {
    scheduleFulfillmentSync(0);
  }, 600);
})();